import React from "react";
import { formatDistanceToNow } from "date-fns";
import { useNavigate } from "react-router";
import { ScrollArea, ScrollBar } from "@acme/ui/scroll-area";
import { Card, CardHeader, CardTitle, CardContent } from "@acme/ui/card";
import { ArrowRightIcon } from "lucide-react";
import { FiCode } from "react-icons/fi";
import { trpc } from "@/trpc";

export function Templates() {
	const navigate = useNavigate();
	const { data: templates } = trpc.templates.recentTemplates.useQuery();

	return (
		<div className="p-4">
			<h1 className="text-2xl font-bold mb-4">Templates</h1>
			<ScrollArea className="pb-4">
				<div className="flex gap-4 w-max p-4">
					{templates?.map((template) => (
						<Card
							key={template.id}
							className="min-w-[250px] cursor-pointer hover:shadow-lg transition-shadow"
							onClick={() => navigate(`/dashboard/templates/${template.id}`)}
						>
							<CardHeader className="p-4">
								<div className="flex items-center gap-2 mb-2">
									<FiCode className="h-6 w-6 text-gray-500" />
									<CardTitle className="text-xl font-semibold">
										{template.name}
									</CardTitle>
								</div>
							</CardHeader>
							<CardContent className="px-4 pb-4">
								<p className="text-sm text-gray-600">Type: {template.type}</p>
								<p className="text-xs text-gray-500">
									Created
									{formatDistanceToNow(template.updatedAt, { addSuffix: true })}
								</p>
							</CardContent>
						</Card>
					))}
				</div>
				<ScrollBar orientation="horizontal" />
			</ScrollArea>
			<button
				type="button"
				onClick={() => navigate("/templates")}
				className="flex items-center gap-2 text-primary font-semibold"
			>
				See All
				<ArrowRightIcon className="h-4 w-4" />
			</button>
		</div>
	);
}
